import { Observable } from 'rxjs'
import { filter, map, withLatestFrom } from 'rxjs/operators'
import { combineEpics, ofType, StateObservable } from 'redux-observable'
import { GlobalState } from 'store'
import { BTQAction } from 'epics'
import { ClientLogStream, LogConfig, LogSeverity, LogSeverityPriority, LogToServerActions, ServerMessageType } from 'api'
import { platformDetailSelector } from 'selectors/platformSelectors'
import { isNotNil } from 'utils/predicate'
import { rateLimit } from './epicUtils'
import { getConfig } from 'configurationLoader'

const shouldLogSeverityForStream = (severity: LogSeverity, logStream: ClientLogStream, config: LogConfig) => {
  const configSeverityForStream = config[logStream]
  return isNotNil(configSeverityForStream) && LogSeverityPriority[severity] <= LogSeverityPriority[configSeverityForStream]
}

export const createLogStreamEpic = <T extends BTQAction['type'], A extends BTQAction = Extract<BTQAction, { type: T }>>(
  entityType: T,
  logStream: ClientLogStream,
  logSeverity: LogSeverity,
  messageFactory: (action: A) => string,
  _filter: (action: A) => boolean = () => true
) => (action$: Observable<BTQAction>, state$: StateObservable<GlobalState>) => {
  const { logStreamMessageCount, logStreamInterval } = getConfig()
  return action$.pipe(
    ofType<BTQAction, T, A>(entityType),
    withLatestFrom(state$),
    filter(([action, state]) => {
      if (!_filter(action)) {
        return false
      }
      const platformDetails = platformDetailSelector(state)
      return (
        isNotNil(platformDetails) && shouldLogSeverityForStream(logSeverity, logStream, platformDetails.platform.clientLogConfig.config)
      )
    }),
    map(([action]) => LogToServerActions.logMessage(logSeverity, messageFactory(action), logStream)),
    rateLimit(logStreamMessageCount, logStreamInterval)
  )
}

const nonSnapshotEntityUpdateLogStreamEpic = createLogStreamEpic(
  ServerMessageType.ENTITY_UPDATE,
  ClientLogStream.ENTITY_UPDATES,
  LogSeverity.INFO,
  action =>
    `ENTITY_UPDATE acknowledge for ${action.payload.update.entityType} entityId ${
      action.payload.update.entityId
    } at ${new Date().toISOString()}`,
  action => action.payload.isSnapshot === false
)

export const logStreamEpic = combineEpics(nonSnapshotEntityUpdateLogStreamEpic)
